import { Link } from '@cian/link-component';
import * as React from 'react';
import { ICountrysideBuilderLandingPromoVillageData } from '../../types';
import { trackTrapLinkClick } from '../../utils/tracking/trackTrapLinkClick';
import { getUTMDataForLink } from '../../utils/getUTMDataForLink';
import { mergeUrlWithAdditionalQuery } from '../../utils/mergeUrlWithAdditionalQuery';
import * as styles from './AsideCountrysideBuilderPromo.css';

export interface IAsideCountrysideBuilderPromoProps {
  data: ICountrysideBuilderLandingPromoVillageData | null;
  offerId: number;
}

export function AsideCountrysideBuilderPromo({ data, offerId }: IAsideCountrysideBuilderPromoProps) {
  if (!data || !data.bannerLink || data.bannerType !== 'section') { return null; }

  const utm = getUTMDataForLink('section', offerId);

  return (
    <div className={styles['container']}>
        <strong className={styles['title']}>Сколько стоит построить здесь дом?</strong>
        <Link
          className={styles['link']}
          href={mergeUrlWithAdditionalQuery(data.bannerLink, utm)}
          target="_blank"
          rel="nofollow noopener"
          onClick={() => trackTrapLinkClick(offerId)}
        >
          <span className={styles['text']}>Узнать цену дома</span>
          <div className={styles['filled']}>
            <span className={styles['caret']} />
          </div>
          <span className={styles['rouble']}>₽</span>

        </Link>
    </div>
  );
}
